import React from 'react';
import './pagination.scss';
import clsx from 'clsx';
import { chevronLeftIcon } from '@/shared/assets'
import { chevronRightIcon } from '@/shared/assets'

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    totalItems: number;
}

export const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange, totalItems }) => {
    if (totalItems === 0 || totalPages <= 1) return null;

    const pagesToShow = 5; // Количество страниц для отображения без эллипсов
    const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

    // Добавляем эллипсы если нужно
    const showStartEllipsis = startPage > 1;
    const showEndEllipsis = endPage < totalPages;

    return (
        <div className="pagination">
            <button 
                onClick={() => onPageChange(currentPage - 1)} 
                disabled={currentPage === 1}
                className={clsx('pagination__button pagination__button__arrow', { 'pagination__button--disabled': currentPage === 1 })}
            >
                <img className='' src={chevronLeftIcon} alt="Previous" />
            </button>
            {showStartEllipsis && (
                <>
                    <button 
                        onClick={() => onPageChange(1)} 
                        className="pagination__button"
                    >
                        1
                    </button>
                    <span className="pagination__ellipsis">...</span>
                </>
            )}
            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                <button 
                    key={startPage + i} 
                    onClick={() => onPageChange(startPage + i)} 
                    className={clsx('pagination__button', {
                        "pagination__button--active": startPage + i === currentPage
                    })}
                >
                    {startPage + i}
                </button>
            ))}
            {showEndEllipsis && (
                <>
                    <span className="pagination__ellipsis">...</span>
                    <button 
                        onClick={() => onPageChange(totalPages)} 
                        className="pagination__button"
                    >
                        {totalPages}
                    </button>
                </>
            )}
            <button 
                onClick={() => onPageChange(currentPage + 1)} 
                disabled={currentPage === totalPages}
                className={clsx('pagination__button pagination__button__arrow', { 'pagination__button--disabled': currentPage === totalPages })}
            >
                <img src={chevronRightIcon} alt="Next" />
            </button>
        </div>
    );
};